import type { ITopCampaignRow } from './goalDetailTopCampaignsColumns';

export interface IUseGoalDetailTopCampaignsReturn {
  hasError: boolean;
  hasMore: boolean;
  isPending: boolean;
  rows: ITopCampaignRow[];
}

// TODO: Replace stub with real fetch once BE endpoint ships (#7890 integration ticket).
export function useGoalDetailTopCampaigns({
  limit,
}: {
  limit: number;
}): IUseGoalDetailTopCampaignsReturn {
  // TODO: Remove test data before merging (#7890).
  const allRows: ITopCampaignRow[] = [];
  return {
    hasError: false,
    hasMore: allRows.length > limit,
    isPending: false,
    // TODO: Replace slice with proper limit implementation on list()
    rows: allRows.slice(0, limit),
  };
}
